export default __webpack_public_path__ + "static/media/sort-asc-arrow.4de09cdd.svg";